module.exports = __webpack_public_path__ + "img/car_selected.407b94c3.png";